export interface ISolidColor {
    alpha: number;
    blue: number;
    green: number;
    hue: number;
    red: number;
    saturation: number;
    style?: string;
    value: number;
}

export interface IGradientColor {
    points: { left: number; red: number; green: number; blue: number; alpha: number }[];
    degree: number;
    type: "linear" | "radial";
    style?: string;
}

export enum ColorPickerModes {
    SOLID,
    GRADIENT,
    IMAGE,
}
export interface IColorPickerResult<V = Exclude<ISolidColor, "style"> | IGradientColor | null> {
    type: ColorPickerModes;
    style: string; // removed uploaded image is NULL
    value: V; // uploaded image value is NULL
}
